import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { useQuery } from "@apollo/client";

import { SKILL_MANY } from "../../schema/skill";
import { SkillGroup, Skill } from "../../types";

import { Loading, Error } from "../ui/Alerts";

interface Props {
  onSubmit: (formData: any) => void;
  data?: SkillGroup;
}

export type FormData = {
  name: string;
  description: string;
  skillIds: Array<string>;
};

const Form = ({ onSubmit, data }: Props) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({ defaultValues: data });
  const { loading, error, data: skillData } = useQuery(SKILL_MANY);

  const options =
    skillData?.skillMany.map(
      (skill: Skill) =>
        ({
          id: skill._id,
          name: skill.name,
        } as any)
    ) || [];

  return (
    <form onSubmit={handleSubmit(onSubmit)} id="slide-over-form">
      <div className="flex-1 flex flex-col justify-between">
        <div className="px-4 divide-y divide-gray-200 sm:px-6">
          <div className="space-y-6 pt-6 pb-5">
            <div className="space-y-1">
              <label
                htmlFor="name"
                className="block text-sm font-medium leading-5 text-gray-900"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                {...register("name", { required: true })}
                className="mt-1 focus:ring-orange-500 focus:border-orange-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />

              {errors.name && (
                <span className="text-sm font-light text-red-500">
                  Name fehlt
                </span>
              )}
            </div>
            <div className="space-y-1">
              <label
                htmlFor="description"
                className="block text-sm font-medium leading-5 text-gray-900"
              >
                Beschreibung
              </label>
              <div className="mt-1">
                <textarea
                  id="description"
                  {...register("description")}
                  className="shadow-sm focus:ring-orange-500 focus:border-orange-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                ></textarea>
              </div>
              <p className="mt-2 text-sm text-gray-500">
                Kurze Beschreibung dieser Kompetenzgruppe
              </p>
            </div>
            <div className="space-y-1">
              {loading && <Loading />}
              {error && <Error error={error} />}
              <label
                htmlFor="skillIds"
                className="block text-sm font-medium leading-5 text-gray-900"
              >
                Kompetenzen
              </label>
              <div className="mt-1">
                <Controller
                  control={control}
                  name="skillIds"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <Select
                      placeholder="Kompetenz wählen..."
                      options={options}
                      value={options.filter(({ id }: any) =>
                        value?.includes(id)
                      )}
                      getOptionLabel={({ name }: any) => name}
                      getOptionValue={({ id }: any) => id}
                      isLoading={loading}
                      isMulti
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onBlur={onBlur}
                      onChange={(values: any) =>
                        onChange((values ?? []).map((d: any) => d.id))
                      }
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
